/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-return-assign */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Form } from '@unform/web';
import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import DatePicker from 'react-horizontal-datepicker';
import { format } from 'date-fns';
import { IoIosWarning } from 'react-icons/io';
import { debounce } from 'lodash';
import { confirmStatus, formatStatus } from '../../../utils/formatStatus';

import Button from '../../../components/Button';
import Input from '../../../components/Input';

import {
  Main,
  Section,
  SearchIcon,
  Calender,
  ButtonWrapperHover,
  RedRoundButton,
  Tooltip,
} from './styles';
import api from '../../../services/api';
import { convertDateString } from '../../../utils/convertDateString';

interface ITodayOrdersDeliveryAddress {
  addressId: string;
  street: string;
  streetNumber: string;
  neighborhood: string;
  apartment: string;
  doorCode: string;
}

interface ITodayOrdersLunch {
  order: string;
  nextOrder: string;
  quantity: string;
  description: string;
  lunchs: string;
}

interface ITodayOrders {
  id: string;
  createdAt: string;
  deliveryDate: any;
  deliveryTime: string;
  deliverymanName: string;
  client: string;
  apartment: string;
  additionalData: string;
  status:
    | 'A_CONFIRMAR'
    | 'COM_PENDENCIA'
    | 'EM_PRODUCAO'
    | 'FINALIZADO'
    | 'ENTREGUE'
    | 'CANCELADA';
  deliveryAddress: ITodayOrdersDeliveryAddress[];
  lunchs: ITodayOrdersLunch[];
}

interface IDeliveryman {
  additionalData: string;
  documentNumber: string;
  iban: string;
  id: string;
  licensePlate: string;
  name: string;
  referenceContactNumber: string;
  vehicleDocument: string;
}

const ProximosPedidos: React.FC = () => {
  const [date, setDate] = useState<Date>(new Date());
  const [loading, setLoading] = useState<boolean>(true);
  const [allOrders, setAllOrders] = useState<ITodayOrders[]>();
  const [nextOrders, setNextOrders] = useState<ITodayOrders[]>();
  const [search, setSearch] = useState('');

  const changeDate = (day: Date) => {
    setDate(day);
  };

  const getDayOrders = async () => {
    const orders = await api.get<ITodayOrders[]>(
      `food-order/day/${format(date, 'yyyy-MM-dd')}`,
    );
    const orderArray = orders.data;
    const replaceOrderArray = orderArray.map((result: any) => {
      const comparationNumber = result.deliveryTime.split(':').join('');
      const formattedNumber = Number(comparationNumber);
      result.formattedNumber = formattedNumber;
      return result;
    });

    const orderByTime = replaceOrderArray.sort((leftDate, rightDate) => {
      return leftDate.formattedNumber - rightDate.formattedNumber;
    });

    setAllOrders(orderByTime);
  };

  const didMount = () => {
    setLoading(true);
    getDayOrders();
    setLoading(false);
  };

  const getDayOrdersWithFilter = async () => {
    const orders = await api.get<ITodayOrders[]>(
      `food-order/day/${format(date, 'yyyy-MM-dd')}`,
    );
    const orderArray = orders.data;
    const replaceOrderArray = orderArray.map((result: any) => {
      const comparationNumber = result.deliveryTime.split(':').join('');
      const formattedNumber = Number(comparationNumber);
      result.formattedNumber = formattedNumber;
      return result;
    });

    const orderByTime = replaceOrderArray.sort((leftDate, rightDate) => {
      return leftDate.formattedNumber - rightDate.formattedNumber;
    });

    setAllOrders(
      orderByTime.filter(order =>
        order.client.toLowerCase().includes(search.toLocaleLowerCase()),
      ),
    );
  };

  const didMountWhithFilter = () => {
    getDayOrdersWithFilter();
  };

  useEffect(() => {
    debouncedData();
  }, [search]);

  const debouncedData = useCallback(
    debounce(() => {
      if (search !== '') {
        didMountWhithFilter();
      } else {
        didMount();
      }
    }, 500),
    [search],
  );

  useEffect(didMount, [date]);

  const getQuantity = (lunchs: ITodayOrdersLunch[]) => {
    let amount = 0;

    lunchs.forEach(lunch => (amount += Number(lunch.quantity)));

    return amount;
  };

  return (
    <>
      <Main>
        <div className="header-main">
          <div>
            <h1>Próximos Pedidos</h1>
            <h3>Acompanhe a sua produção no período selecionado</h3>
          </div>
          <Link to="/novo-pedido">
            <Button type="button">+ Novo Pedido</Button>
          </Link>
        </div>
        <Section>
          <div className="sectionCard">
            <Calender>
              <DatePicker
                getSelectedDay={(e: Date) => changeDate(e)}
                labelFormat="MMMM"
                color="#BF1E2D"
                endDate={90}
              />
            </Calender>
            <Form onSubmit={() => {}}>
              <div className="searchBar">
                <SearchIcon />
                <Input
                  name="search"
                  type="text"
                  onChange={e => setSearch(e.target.value)}
                  placeholder="Procure por nome"
                />
              </div>
            </Form>
            <h2>Próximos Pedidos</h2>
            <div className="flex-container">
              <div>
                <h3>Data da Entrega</h3>
              </div>
              <div>
                <h3>Horário de Entrega</h3>
              </div>
              <div>
                <h3>Cliente</h3>
              </div>
              <div
                style={{
                  minWidth: '180px',
                  display: 'flex',
                  flexDirection: 'column',
                  marginBottom: '16px',
                }}
              >
                <h3>Endereço</h3>
              </div>
              <div>
                <h3>Apartamento</h3>
              </div>
              <div>
                <h3>Pedido</h3>
              </div>
              <div>
                <h3>Status da Produção</h3>
              </div>
              <div className="item">Item</div>
            </div>

            {!loading &&
              allOrders?.length !== 0 &&
              allOrders !== undefined &&
              allOrders.map(order => (
                <div key={order.id} className="flex-container">
                  <div>{convertDateString(order.deliveryDate)}</div>
                  <div>{order.deliveryTime.substr(0, 5)}</div>
                  <div>{order.client}</div>
                  <div
                    style={{
                      minWidth: '180px',
                      display: 'flex',
                      flexDirection: 'column',
                      marginBottom: '16px',
                    }}
                  >
                    {order.deliveryAddress[0].street} - n
                    {order.deliveryAddress[0].streetNumber}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      textAlign: 'center',
                      flexDirection: 'column',
                      marginBottom: '16px',
                    }}
                  >
                    {order.apartment}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginBottom: '16px',
                    }}
                  >
                    {order.lunchs.map((i, index) => (
                      <div key={String(index)}>
                        {index < 3 ? `${i.quantity} - ${i.order}` : `...`}
                      </div>
                    ))}
                    <div
                      style={{ position: 'relative', display: 'inline-block' }}
                    >
                      {order.additionalData && (
                        <ButtonWrapperHover>
                          {order.additionalData && (
                            <>
                              <RedRoundButton>
                                <span>!</span>
                              </RedRoundButton>
                              <Tooltip>{order.additionalData}</Tooltip>
                            </>
                          )}
                        </ButtonWrapperHover>
                      )}
                    </div>
                  </div>
                  <div>
                    <div className={confirmStatus(order.status)}>
                      <span>{formatStatus(order.status)}</span>
                    </div>
                  </div>
                  <div>
                    <Link to={`/producao-do-dia-detalhe/${order.id}`}>
                      <Button className="button-plus">
                        <span>+</span>
                      </Button>
                    </Link>
                  </div>
                </div>
              ))}
            {allOrders?.length === 0 && (
              <h2>
                Você não possui Próximos Pedidos cadastrados nessa data...
              </h2>
            )}
            {loading && (
              <div className="loadingData">
                <span>Carregando...</span>
              </div>
            )}
          </div>
        </Section>
      </Main>
    </>
  );
};

export default ProximosPedidos;
